/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createSelector } from 'reselect';

const platformsSelector = state => state.enums.platforms;

export const platOptsSelector = createSelector(
  platformsSelector,
  (platforms) => {
    const { status } = platforms;
    if (status === 'success') {
      return platforms.data.list.map(l => ({
        label: l.name,
        value: l.name,
      }));
    }
    return [];
  },
);




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayAdd/selectors.js